<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật Trường học: {{ modelData.name }}</h2>
        <el-button v-if="accountInfo.user_type == 1" @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="24">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="avatar" label="Logo">
                  <el-upload
                    class="avatar-uploader"
                    :action="upload.url"
                    :headers="upload.headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :on-progress="handleAvatarProcess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="modelData.logo_path" :src="modelData.logo_path" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">
                      <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                      Logo tải lên có dung lượng tối đa là 2Mb
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item prop="name" label="Tên Trường học" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" clearable ref="myInput"></el-input>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="code" label="Mã trường học" class="form-item">
                      <el-input v-model="modelData.code" class="input-seach"></el-input>
                    </el-form-item>
                    <el-form-item prop="hotline_home" label="Hotline home" class="form-item">
                      <el-input v-model="modelData.hotline_home" class="input-seach" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="fanpage" label="Fanpage FB" class="form-item">
                      <el-input v-model="modelData.fanpage" class="input-seach" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="skype" label="Skype" class="form-item">
                      <el-input v-model="modelData.skype" class="input-seach" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="email" label="Email" class="form-item">
                      <el-input v-model="modelData.email" class="input-seach" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="hotline_mobile" label="Hotline mobile" class="form-item">
                      <el-input v-model="modelData.hotline_mobile" class="input-seach" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="zalo_link" label="Zalo Link" class="form-item">
                      <el-input v-model="modelData.zalo_link" class="input-seach" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="description" label="Mô tả ngắn" class="form-item">
                      <el-input v-model="modelData.description" class="input-seach" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="avatar" label="Banner">
                  <el-upload
                    class="avatar-uploader"
                    :action="upload.url2"
                    :headers="upload.headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    :on-progress="handleAvatarProcess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="modelData.banner_path" :src="modelData.banner_path" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">
                      <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                      Banner tải lên có dung lượng tối đa là 2Mb
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item prop="address" label="Địa chỉ chính" class="form-item">
                  <el-input v-model="modelData.address" class="input-seach" clearable></el-input>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item prop="city_code" label="Thành phố" class="form-item">
                      <el-select v-model="modelData.city_code" filterable placeholder="Thành phố" class="input-select">
                        <el-option
                          v-for="item in listCitis"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="district_code" label="Quận huyện" class="form-item">
                      <el-select v-model="modelData.district_code" filterable placeholder="Quận huyện" class="input-select">
                        <el-option
                          v-for="item in listDistricts"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="ward_code" label="Phường xã" class="form-item">
                      <el-select v-model="modelData.ward_code" filterable placeholder="Phường xã" class="input-select">
                        <el-option
                          v-for="item in listWards"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="Địa chỉ cơ sở con" class="form-item">
                  <div
                    v-for="(item, index) in modelData.address_sub"
                    :label="'Thuộc tính' + (index + 1)"
                    :key="item.key"
                  >
                  <el-row :gutter="10">
                    <el-col :span="22">
                      <el-input v-model="item.unit_vi" placeholder="Địa chỉ cơ sở con" class="input-seach" clearable></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button @click.prevent="removeDomain(item)" size="small">
                        <i class="fas fa-trash-alt"></i>
                      </el-button>
                    </el-col>
                  </el-row>
                  </div>
                  <div>
                    <el-button @click="addDomain" size="small" type="info">
                      Thêm cơ sở
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20">
                <el-form-item prop="content" label="Thông tin giới thiệu">
                  <tinymce
                    id="d3"
                    v-model="modelData.content"
                    :toolbar1="tinymce.toolbar1"
                    :other_options="{ height: '500px', images_upload_handler: handleImageAdded , language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'CategoryBlogUpdate',
  metaInfo () {
    return {
      title: 'Trường học'
    }
  },
  components: {
    tinymce
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      modelData: {
        name: '',
        parant_id: '',
        priority: '',
        city_code: '',
        district_code: '',
        ward_code: '',
        status: false
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'schools/upload',
        url2: process.env.API_URI + 'schools/upload-not-resize',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      listCategories: [],
      listCitis: [],
      listDistricts: [],
      listWards: [],
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên trường học' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.configUpload()
    this.fetchCitis()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('schools/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path_sm)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'schools-index', text: 'Trường học' },
        { name: 'schools-update', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'schools-index'})
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchCitis () {
      axios.get('cities', {params: {'status': 1, 'limit': -1, 'sort': 'id:1'}}).then(response => {
        switch (response.code) {
          case 200:
            this.listCitis = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchDistricts () {
      axios.get('districts', {params: {'status': 1, 'limit': -1, 'sort': 'id:1', 'city_code': this.modelData.city_code}}).then(response => {
        switch (response.code) {
          case 200:
            this.listDistricts = response.data
            // this.modelData.district_code = ''
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchWards () {
      axios.get('wards', {params: {'status': 1, 'limit': -1, 'sort': 'id:1', 'district_code': this.modelData.district_code}}).then(response => {
        switch (response.code) {
          case 200:
            this.listWards = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu
    fetchListCategories () {
      axios.get('schools/get-recursive-schools').then(response => {
        switch (response.code) {
          case 200:
            this.listCategories = response.data.categories
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('schools/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          case 422:
            this.$router.push({name: 'home-index'})
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          console.log('Lỗi validate')
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('schools/' + this.$route.params.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            if (this.accountInfo.user_type === 1) {
              this.$router.push({name: 'schools-index'})
            }
            // this.$router.push({name: 'schools-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Địa chỉ con
    removeDomain (item) {
      var index = this.modelData.address_sub.indexOf(item)
      if (index !== -1) {
        this.modelData.address_sub.splice(index, 1)
      }
    },
    addDomain () {
      this.modelData.address_sub.push({
        key: Date.now(),
        address: ''
      })
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh đại diện có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.logo = response.data.name
        this.modelData.logo_path = response.data.path
      }
    },
    handleAvatarSuccess2 (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.banner = response.data.name
        this.modelData.banner_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  },
  watch: {
    'modelData.city_code': function () {
      if (this.modelData.city_code) {
        this.fetchDistricts()
      }
    },
    'modelData.district_code': function () {
      if (this.modelData.district_code) {
        this.fetchWards()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/schools/Update.vue